import type { Components, Theme } from '@mui/material/styles';

export const MuiSlider: Components<Theme>['MuiSlider'] = {
  defaultProps: {},
  styleOverrides: {
    root: {},

    rail: {
      bgcolor: 'var(--mui-palette-neutral-100)',
      opacity: 1,
      height: '6px',
    },
  },
};
